export default __webpack_public_path__ + "javascripts/components/Podcast/SubscriptionOption/spotify-c0f4a833fe7182ccb0f2f8eaeea703d0.svg";